import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

export const GROK_AI_CONTENT: AiModelContent = {
  id: 'grok',
  tabLabel: 'Grok',
  displayName: 'Grok',
  countryList: [
    Country.ES,
    Country.FR,
    Country.AR,
    Country.GB_ENG,
    Country.MA,
    Country.CO,
    Country.SN,
    Country.UY,
    Country.TR,
    Country.SE,
  ],
  listValid: true,
  responseTimeSeconds: 20,
  imageSrc: placeholderImage,
  justificationText: `Methodology: Current FIFA rankings/power lists show Spain/France/Argentina/England as consensus top contenders for deep runs (QF+), with high expected raw points from group wins, knockouts, and goals. Morocco (strong recent WC performer) and Colombia/Senegal/Uruguay offer reliable intermediate upside for R16/QF with lower variance. Outsiders Türkiye/Sweden add high-reward variance (potential R16 surprises via talent like Isak/Gyokeres or young squad momentum) for min 2 requirement while weighting low. Strategy prioritizes favorites at high multipliers for expected value, balanced with value picks.

Biggest risk: Over-reliance on European/South American powerhouses if early upsets or fatigue (hosts advantage, travel) hit; outsiders may underperform. (~180 words)`,
};
